// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'

import {
  filterAFSGridPaths,
  getAnalysisResults,
  updateInterferenceAnalysisState,
} from 'redux/modules/interferenceAnalysis'

// TODO - so.... how do we properly deal with errors here?
// let's say for example, the AFS_GRID_FILTER.applyResultFilter was just
// changed and so this function is triggered but it failed.
// Should the form revert to its previous value?

// This would trigger updateAnalysisResults to fire again on the previous value.
// This could cause a chain reaction, how would that be handled?

// getAnalysisResults is what would fail here and it will show
// a notification for the API response. but is that enough?

// This is called:
// - when specific AFS_GRID_FILTER fields are changed:
// - - applyResultFilter
// - - bandId
// - - analysisTypeId
// - from within handleFrequencyFlip after it successfully flips its paths
// - - called within a try/catch here
// - at the tail of initializeInterferenceAnalysis

const updateAnalysisResults = () => async dispatch => (
  dispatch(loadingToggler(
    async () => {
      // we need to clear out the visible paths before getting the analysis results
      // to prevent the ui from trying to display the former visibleGroupedFrequencyPlans
      // based on the updated analysisResults => groupedFrequencyPlans
      await dispatch(updateInterferenceAnalysisState({
        visibleGroupedFrequencyPlans: [],
      }))

      // gets the actual results to display in the grid
      await dispatch(getAnalysisResults())

      // filters which paths should be displayed based on the
      // redux > projectSummary > paths and
      // the applied values in AFS_GRID_FILTER
      await dispatch(filterAFSGridPaths())
    })
  )
)

export default updateAnalysisResults
